import {
	Button,
	Container,
	Grid,
	IconButton,
	Tab,
	Tabs,
	Typography,
} from "@mui/material";
import PropTypes from "prop-types";
import { Box } from "@mui/system";
import React from "react";
import { useState } from "react";
import { alertMsg } from "../utils/basicUtils";
import { useTheme } from "@emotion/react";
import ReactCompareImage from "react-compare-image";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import useAxiosPrivate from "../hooks/use-axios-private";
import { APP_CURRENCY, APP_DATE_FORMAT, JOB_STATUS } from "../constants";
import CloseIcon from '@mui/icons-material/Close';
import Empty from "../components/Empty";
import ModeEditOutlinedIcon from '@mui/icons-material/ModeEditOutlined';
import Skeleton from '@mui/material/Skeleton';
import useAuth from "../hooks/use-auth";
import { ROLE } from "../constants";
import Popup from "../components/Popup";
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import Modal from '@mui/material/Modal';
import Badge from '@mui/material/Badge';
import ImageIcon from '@mui/icons-material/Image';
import { LazyLoadImage } from "react-lazy-load-image-component";
import ModalBox from "../components/ModalBox";
import { Field, Form, Formik } from "formik";
import { TextField } from "formik-mui";
import * as Yup from 'yup';
import StrictNumberField from "../components/StrictNumberField";

const refundValidation = Yup.object({
	job_id: Yup.string()
		.required('Job ID is required'),
	amount: Yup.number()
		.required('Refund amount is required')
		.min(0, `Refund amount shouldn't be negative`)
		.max(10000, 'Refund amount cannot exceed 10000')
		.test(
			"DecimalPlaces",
			"Decimal places does not exceed 2 characters",
			(number) => Number.isInteger(number * 100)
		),
	reason: Yup.string()
		.required('Refund reason is required')
		.max(255, 'Refund reason cannot exceed 255 characters'),
})

function TabPanel(props) {
	const { children, value, index, ...other } = props;

	return (
		<div
			role="tabpanel"
			hidden={value !== index}
			id={`simple-tabpanel-${index}`}
			aria-labelledby={`simple-tab-${index}`}
			{...other}
		>
			{value === index && <Box sx={{ py: 3 }}>{children}</Box>}
		</div>
	);
}

TabPanel.propTypes = {
	children: PropTypes.node,
	index: PropTypes.number.isRequired,
	value: PropTypes.number.isRequired,
};

const Marker = ({ hotspot, style, index }) => {
	//  const [showText, setShowText] = useState(type === 'new');
	// const [commentText, setCommentText] = useState(hotspot.text);

	return (

		<Box>
			<div
				style={
					{
						color: "#fff",
						position: "absolute",
						// left: `${hotspot.x}%`,
						// top: `${hotspot.y}%`,
						left: `calc(${hotspot.x}% - 5px)`,
						top: `calc(${hotspot.y}% - 3px)`,
						backgroundColor: "#3f51b5",
						borderRadius: "50%",
						// padding: "5px",
						width: "15px",
						height: "15px",
						fontSize: 10,
						display: "flex",
						alignItems: "center",
						justifyContent: 'center',
						border: "2px solid #fff",

						...style
					}
				}

			>
				<div>{index}</div>
			</div>
		</Box>
	)
}

const Comment = ({ hotspot, index }) => {
	const theme = useTheme();
	return (
		<Box
			bgcolor={
				theme.palette.mode === "dark"
					? "background.sidebar"
					: "background.stripped"
			}
			sx={{ px: 2, py: 1.5, mt: 1, borderRadius: "6px" }}
		>
			<Box
				sx={{
					display: "flex",
					alignItems: "center",
					justifyContent: "space-between",
				}}
			>
				<Box sx={{ display: "flex", alignItems: "center" }}>
					<Typography
						sx={{
							marginRight: "15px",
							backgroundColor:
								theme.palette.mode === "dark" ? "#5a5a5a" : "#e2e2e2",
							borderRadius: "50%",
							display: "flex",
							alignItems: "center",
							justifyContent: "center",
							minWidth: "28px",
							minHeight: "28px",
							width: "28px",
							height: "28px",
						}}
					>
						{index + 1}
					</Typography>
					<Typography sx={{ fontSize: "14px", lineHeight: "16px" }}>{hotspot.text}</Typography>
				</Box>
			</Box>
		</Box>
	);
};

const Viewjob = ({ jobId }) => {
	const [mediaList, setMediaList] = useState([]);
	const navigate = useNavigate();
	const [job, setJob] = useState(false);
	const theme = useTheme();
	const [value, setValue] = React.useState(0);
	const [open, setOpen] = React.useState(false);
	const handleOpen = () => setOpen(true);
	const handleClose = () => setOpen(false);
	const [paymentInfo, setPaymentInfo] = useState(false);
	const [showAlert, setShowAlert] = useState(false);
	const [preferences, setPreferences] = useState([])
	const [openRefundModal, setOpenRefundModal] = useState(false)
	const [refundInfo, setRefundInfo] = useState([])

	const axios = useAxiosPrivate();
	const { protector } = useAuth();

	const handleChange = (event, newValue) => {
		setValue(newValue);
	};

	const getJob = async () => {
		try {
			const resp = await axios.get(`/jobs/${jobId}`);
			setMediaList(resp.data.data.job.media);
			console.log("get job", resp)
			setJob(resp.data.data.job);
			setPaymentInfo(resp.data.data.payment_info);
			setRefundInfo(resp.data.data.refund_list)
			let preferences = []
			if (resp.data.data.job.base_preferences_lst && resp.data.data.job.base_preferences_lst.length >= 1) {
				preferences = resp.data.data.job.base_preferences_lst
			}
			if (resp.data.data.job.preferences_lst && resp.data.data.job.preferences_lst.length >= 1) {
				preferences.push(...resp.data.data.job.preferences_lst)
			}
			setPreferences([...preferences])
		} catch (error) {
			console.error("🚀 ~ file: Viewjob.jsx:197 ~ getJob ~ error:", error)
			alertMsg("Failed to get job");
		}
	};

	const deleteMedia = async () => {
		try {
			const resp = await axios.post("jobs/delete_media/", {
				job_id: jobId,
			});
			alertMsg(resp.data.message, "success")
			getJob();
		} catch (error) {
			console.error(error);
		}
	};

	useEffect(() => {
		getJob();
	}, []);

	const [compareImg, setCompareImg] = useState({
		hotspots: [],
	});

	const modalStyles = {
		position: 'absolute',
		top: '50%',
		left: '50%',
		transform: 'translate(-50%, -50%)',
		width: 630,
		bgcolor: 'background.paper',
		borderRadius: "12px",
		boxShadow: 24,
		p: 4,
		outline: "none",
		maxHeight: "88vh",
		overflow: 'hidden',
		'@media (max-width: 700px)': {
			width: '80%',
			maxWidth: '80%',
			marginLeft: "auto",
			marginRight: "auto",
			p: 3,
		},
		'@media (max-width: 425px)': {
			width: '82%',
			maxWidth: '82%',
			marginLeft: "auto",
			marginRight: "auto",
			p: 2
		},
	};

	return (
		<Container maxWidth="xl">
			<Box sx={{ mt: 4 }}>
				<Box sx={{ display: "flex", alignItems: 'center' }}>
					<IconButton size="small" onClick={() => navigate("/jobs")}>
						<ArrowBackIcon
							color="primary"
							sx={{ fontSize: { xs: 22, xl: 30 }, cursor: "pointer" }}
						/>
					</IconButton>
					<Box>
						<Typography sx={{ fontSize: { xs: 20, xl: 22 }, fontWeight: 500, ml: 1, textTransform: "capitalize" }}>{job.title}</Typography>
					</Box>
				</Box>
			</Box>
			<Box sx={{ mt: 2 }}>
				<Box sx={{ borderBottom: 1, borderColor: "rgba(0, 0, 0, 0.12)" }}>
					<Tabs
						value={value}
						onChange={handleChange}
						variant="scrollable"
						scrollButtons="auto"
					>
						<Tab label="Job Information" />
						<Tab label={
							<Box sx={{ display: "flex", alignItems: "center" }}>
								Gallery
								<Badge
									badgeContent={(job.status === JOB_STATUS.completed && !job.is_media_cleared) ? job.completed[0].images.length : job.media && job.media.length}
									color="primary" className='cs-badge' sx={{ ml: 2 }}>
								</Badge>
							</Box>
						}
						/>
						{protector([ROLE.sa, ROLE.admin, ROLE.client]) &&
							<Tab label="Payment Information" />
						}
					</Tabs>
				</Box>
				<TabPanel value={value} index={0}>
					<Grid container spacing={2} sx={{ mt: 2, alignItems: "center" }}>
						<Grid item xs={12} sm={3}>
							<Typography color={"#767676"}>Job Name</Typography>
						</Grid>
						<Grid item xs={12} sm={9}>
							{
								job ? <Typography sx={{ fontSize: 15 }}>{job.title}</Typography> :
									<Skeleton variant="rounded" width={"20%"} height={25} />
							}
						</Grid>
					</Grid>
					<Grid container spacing={2} sx={{ mt: 1, alignItems: "center" }}>
						<Grid item xs={12} sm={3}>
							<Typography color={"#767676"}>Output file count</Typography>
						</Grid>
						<Grid item xs={12} sm={9}>
							{
								job ? <Typography sx={{ fontSize: 15 }}>{job.output_file_count}</Typography> :
									<Skeleton variant="rounded" width={"20%"} height={25} />
							}
						</Grid>
					</Grid>
					<Grid container spacing={2} sx={{ mt: 1, alignItems: "center" }}>
						<Grid item xs={12} sm={3}>
							<Typography color={"#767676"}>Choose Service</Typography>
						</Grid>
						<Grid item xs={12} sm={9}>
							{/* <Typography>Sample Service</Typography> */}
							{
								job ? <Typography sx={{ fontSize: 15 }}>
									{job.service_lst.map((service) => service.name).join()}
								</Typography> :
									<Skeleton variant="rounded" width={"20%"} height={25} />
							}
						</Grid>
					</Grid>
					<Grid container spacing={2} sx={{ mt: 1, alignItems: "center" }}>
						<Grid item xs={12} sm={3}>
							<Typography color={"#767676"}>Editing Preference</Typography>
						</Grid>
						<Grid item xs={12} sm={9}>
							{
								job ? preferences.length >= 1 ? (
									<Typography sx={{ fontSize: 15 }}>
										{preferences
											.map((preferences) => preferences.name)
											.join()}
									</Typography>
								) : (
									<Typography sx={{ fontSize: 15 }}>No editing preferences are selected</Typography>
								) : <Skeleton variant="rounded" width={"80%"} height={25} />
							}
						</Grid>
					</Grid>
					<Grid container spacing={2} sx={{ mt: 1, alignItems: "center" }}>
						<Grid item xs={12} sm={3}>
							<Typography color={"#767676"}>Turn Around Time</Typography>
						</Grid>
						<Grid item xs={12} sm={9}>
							{
								job ? <Typography sx={{ fontSize: 15 }}>{job.turn_around_time} Hrs</Typography> :
									<Skeleton variant="rounded" width={"10%"} height={25} />
							}
						</Grid>
					</Grid>
					<Grid container spacing={2} sx={{ mt: 1, alignItems: "center" }}>
						<Grid item xs={12} sm={3}>
							<Typography color={"#767676"}>Delivery Time</Typography>
						</Grid>
						<Grid item xs={12} sm={9}>
							{
								job ? <Typography sx={{ fontSize: 15 }}>  {moment(job.delivery_time).format(APP_DATE_FORMAT)}</Typography> :
									<Skeleton variant="rounded" width={"10%"} height={25} />
							}
						</Grid>
					</Grid>
					<Grid container spacing={2} sx={{ mt: 2, alignItems: "center" }}>
						<Grid item xs={12} sm={3}>
							<Typography color={"#767676"}>Notes</Typography>
						</Grid>
						<Grid item xs={12} sm={9}>
							{
								job ? <Typography sx={{ fontSize: 15 }}>{job.notes ? job.notes : "No notes are given"}</Typography> :
									<Skeleton variant="rounded" width={"30%"} height={25} />
							}
						</Grid>
					</Grid>
					{/* <Box sx={{ width: '100%', mt: 2 }}>
                      <Stepper activeStep={1} alternativeLabel>
                          {steps.map((label) => (
                              <Step key={label}>
                                  <StepLabel>{label}</StepLabel>
                              </Step>
                          ))}
                      </Stepper>
                  </Box> */}
				</TabPanel>
				<TabPanel value={value} index={1}>
					<Box>
						<Typography sx={{ p: 1, fontWeight: 500, textAlign: "center" }} >
							{(job.status !== JOB_STATUS.completed || (!job.is_media_cleared && job.completed[0].images.length >= 1)) && "Click the images to view the instruction given"}
						</Typography>
						<Box
							sx={{
								height: 600,
								maxHeight: 600,
								mt: 2,
								overflowY: "auto",
								overflowX: "hidden",
								pr: 4,
							}}
							className="overflow-scroll"
						>
							<Box sx={{ textAlign: "right", whiteSpace: "nowrap" }}>
								{job.status === JOB_STATUS.completed && !job.is_media_cleared && job.completed_zip_url && (
									<a href={job.completed_zip_url[0]}>
										<Button
											variant="contained"
											sx={{}}
										>
											Download Zip
										</Button>
									</a>
								)}
							</Box>
							<Grid
								container
								spacing={2}
								sx={{ justifyContent: "center", m: 0 }}
							>
								{job.status === JOB_STATUS.completed
									?
									!job.is_media_cleared
										?
										job.completed[0].images.length >= 1 ?

											job.completed[0].images.map((item, index) => {
												return (
													<Grid
														item
														key={index}
														xs={12}
														sm={6}
														md={4}
														lg={3}
													>
														<Box sx={{ height: "250px", position: "relative" }}>
															<img
																style={{
																	borderRadius: "6px",
																	width: "100%",
																	cursor: "pointer",
																	height: "100%",
																	objectFit: "cover",
																}}
																src={item.after_image}
																alt={item.title}
																onClick={() => {
																	handleOpen();
																	setCompareImg(item);
																}}
																loading="lazy"
															/>
															<a href={item.after_image} style={{ position: "absolute", top: 10, right: 10 }} download target="_blank" rel="noreferrer">
																<Button
																	variant="contained"
																	sx={{ minWidth: 0, px: 1 }}
																>
																	<FileDownloadOutlinedIcon />
																</Button>
															</a>
														</Box>
													</Grid>
												)
											})
											:
											<Empty icon={<ImageIcon sx={{ fontSize: { xs: 30, md: 50, lg: 60 }, color: "grey" }} />} sx={{ width: "100%", py: 5, my: 3 }} text="No images uploaded" />
										:
										(
											<Typography>
												Upload images are cleared on{" "}
												{moment(job.media_deleted_on).format(APP_DATE_FORMAT)}
											</Typography>
										)
									:
									mediaList && (
										mediaList.map((item, index) => (
											<Grid
												item
												key={index}
												xs={12}
												sm={6}
												md={4}
												lg={3}
												sx={{ height: "250px" }}
											>
												<LazyLoadImage style={{
													borderRadius: "6px",
													width: "100%",
													cursor: "pointer",
													height: "100%",
													objectFit: "cover",
												}}
													placeholder={<span>Loading image</span>}
													src={item.preview_url}
													alt={item.title}
													onClick={() => {
														handleOpen();
														setCompareImg(item);
													}}
												/>
											</Grid>
										))
									)
								}
							</Grid>
							<Box sx={{ textAlign: "center", whiteSpace: "nowrap" }}>
								{job.status === JOB_STATUS.completed && !job.is_media_cleared && job.completed[0].images.length >= 1 && (
									<Button
										variant="contained"
										sx={{ mt: 5 }}
										onClick={() => {
											setShowAlert(true)
										}}
									>
										Clear Raw & Completed Images
									</Button>
								)}
							</Box>
						</Box>
					</Box>
				</TabPanel>
				<Popup show={showAlert} onSecondaryClick={() => setShowAlert(false)} title={"Raw & Completed Images"} consent={true} variant='error' primaryBtnTxt={"Clear"}
					onPrimaryClick={async (e, loader) => {
						if (e.detail !== 1) {
							return false
						}
						try {
							loader(true)
							await deleteMedia()
							setShowAlert(false)
							loader(false)
						}
						catch (error) {
							console.error(error)
						}
					}}
				>
					<Box sx={{ mt: 2, textAlign: "center" }}>
						<Typography variant='span' sx={{ fontSize: { xs: "16px", xl: "18px" }, fontWeight: "400", color: theme.palette.mode === "dark" ? theme.palette.primary.contrastText : theme.palette.primary.main }}>Are you sure you want to clear</Typography>
						<Typography variant='span' sx={{ fontSize: { xs: "16px", xl: "18px" }, fontWeight: "500", color: theme.palette.mode === "dark" ? theme.palette.primary.contrastText : theme.palette.primary.main }}>"Raw & Completed Images"?</Typography>
					</Box>
					<Box sx={{ marginTop: "6px", textAlign: "center" }}>
						<Typography sx={{ fontSize: { xs: "16px", xl: "18px" }, fontWeight: "400", color: theme.palette.mode === "dark" ? theme.palette.primary.contrastText : theme.palette.primary.main }}>You can't undo this action.</Typography>
					</Box>
				</Popup>
				{
					protector([ROLE.sa, ROLE.admin, ROLE.client]) &&
					<TabPanel value={value} index={2}>
						<Grid container spacing={2} sx={{ mt: 2, alignItems: "center" }}>
							<Grid item xs={12} sm={3}>
								<Typography color={"#767676"}>Gross Price</Typography>
							</Grid>
							<Grid item xs={12} sm={9}>
								{
									paymentInfo ? <Typography sx={{ fontSize: 15 }}>{APP_CURRENCY.currency_symbol} {paymentInfo.gross_price}</Typography> :
										<Skeleton variant="rounded" width={"20%"} height={25} />
								}

							</Grid>
						</Grid>
						<Grid container spacing={2} sx={{ mt: 2, alignItems: "center" }}>
							<Grid item xs={12} sm={3}>
								<Typography color={"#767676"}>Discount</Typography>
							</Grid>
							<Grid item xs={12} sm={9}>
								{
									paymentInfo ? <Typography sx={{ fontSize: 15 }}>{APP_CURRENCY.currency_symbol} {paymentInfo.discount_amount}</Typography> :
										<Skeleton variant="rounded" width={"20%"} height={25} />
								}
							</Grid>
						</Grid>
						<Grid container spacing={2} sx={{ mt: 2, alignItems: "center" }}>
							<Grid item xs={12} sm={3}>
								<Typography color={"#767676"}>Net Price</Typography>
							</Grid>
							<Grid item xs={12} sm={9}>
								{
									paymentInfo ? <Typography sx={{ fontSize: 15 }}>{APP_CURRENCY.currency_symbol} {paymentInfo.net_price}</Typography> :
										<Skeleton variant="rounded" width={"20%"} height={25} />
								}
							</Grid>
						</Grid>
						{
							refundInfo.length > 0 && <Grid container spacing={2} sx={{ mt: 2, alignItems: "center" }}>
								<Grid item xs={12} sm={3}>
									<Typography color={"#767676"}>Refund</Typography>
								</Grid>
								<Grid item xs={12} sm={9}>
									<Typography sx={{ fontSize: 15 }}>{APP_CURRENCY.currency_symbol} {refundInfo.map(r => r.amount).reduce((total, amt) => Number(total) + Number(amt), 0).toFixed(2)}</Typography>
								</Grid>
							</Grid>
						}
						{protector([ROLE.sa, ROLE.admin]) && paymentInfo.net_price > 0 &&
							< Box sx={{ display: "flex", justifyContent: "right" }}>
								{/* <Button variant="contained" sx={{ m: 1 }} onClick={() => navigate('/editinvoice', { state: paymentInfo })}>Edit Invoice</Button> */}
								<Button variant="contained" sx={{ m: 1 }} onClick={() => setOpenRefundModal(true)}>Refund</Button>
							</Box>
						}
					</TabPanel>
				}
				<Modal
					open={open}
					onClose={handleClose}
				>
					<Box sx={modalStyles}>
						<Box
							sx={{ maxHeight: "80vh", overflow: "auto" }}
							className="scroll-none"
						>
							<Box sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: "10px" }}>
								<Box>
									<Typography sx={{ fontSize: { xs: 20, xl: 22 }, fontWeight: "500", color: theme.palette.mode === "dark" ? theme.palette.primary.contrastText : theme.palette.primary.main }}>Image Preview</Typography>
								</Box>
								<Box onClick={() => setOpen(false)} sx={{ textAlign: "right", }}>
									<CloseIcon sx={{
										fontSize: '26px', border: "0.25px solid tomato", color: "tomato", padding: "2px", borderRadius: "4px", cursor: "pointer", transition: "0.4s",
										'&:hover': {
											background: "#ff4040",
											color: "#fff"
										},
									}}></CloseIcon>
								</Box>
							</Box>
							{JOB_STATUS.completed === job.status ? (
								<>
									<Box>
										<Box sx={{ mt: 2 }}>
											<Box className="img-prev-hght" style={{ position: "relative", height: 350, overflow: "hidden" }}>
												<ReactCompareImage
													// rightImageCss={{ width: "100%", maxHeight: "350px" }}
													// leftImageCss={{ width: "100%", maxHeight: "350px" }}
													leftImage={compareImg.before_image}
													rightImage={compareImg.after_image}
													style={{ position: "relative" }}
												/>
												{/* {compareImg.hotspots && compareImg.hotspots.map((item, index) => {
													return <Box style={{ position: "absolute", left: `${item.x}%`, top: `${item.y}%`, zIndex: 1999 }}>
														<Typography sx={{
															color: "#fff",
															backgroundColor: "#3f51b5",
															borderRadius: "50%",
															width: "30px",
															height: "30px",
															display: "flex",
															alignItems: "center",
															justifyContent: 'center',
															border: "2px solid #fff",
														}}>{index + 1}</Typography>
													</Box>
												})} */}
											</Box>
											<Box
												sx={{
													color: theme.palette.mode === "dark" ? "#fff" : "#000", mt: 2,
												}}
											>
												<Typography sx={{ fontWeight: 500 }}>Comments</Typography>
												<Box
													maxHeight={280}
													sx={{ pr: 0.7, overflowY: "auto", mt: 1.3 }}
													className="overflow-scroll"
												>

													{compareImg.hotspots && compareImg.hotspots.length > 0 ? (
														compareImg.hotspots.map(
															(hotspot, index) =>
																hotspot.text && (
																	<>
																		<Comment key={index} {...{ hotspot, index }} />
																	</>
																)
														)
													) : (
														<Empty icon={<ModeEditOutlinedIcon />} sx={{ mb: 0, textTransform: "capitalize" }} text="no comments" />
													)}
												</Box>
											</Box>
										</Box>
									</Box>
								</>

							) :
								(
									<>

										<Box sx={{ width: { xs: '100%', sm: '600px' }, height: { xs: '400px', sm: '600px' }, position: "relative" }} >
											{/* <Canvas previewUrl={compareImg.marked_image ? compareImg.marked_image : compareImg.preview_url}
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                      }} /> */}
											{compareImg.marked_image
												?
												<img
													style={{
														width: "100%",
														height: "100%",
														objectFit: "contain",
													}}
													src={compareImg.marked_image.url}
													alt={compareImg.title}
													loading="lazy"
												/>
												:
												<img
													style={{
														width: "100%",
														height: "100%",
														objectFit: "contain",
													}}
													src={compareImg.preview_url}
													alt={compareImg.title}
													loading="lazy"
												/>
											}
											<Box className="comments-hide">
												{compareImg.hotspots.map(
													(hotspot, index) =>
														hotspot.text && (
															<>
																<Marker key={index} {...{ hotspot, index: index + 1 }} />
															</>
														)
												)}
											</Box>
										</Box>

										{/* <Box
                      sx={{
                        borderRadius: "6px",
                        width: "100%",
                        cursor: "pointer",
                        height: { xs: 300, sm: 400 },
                        overflow: "hidden",
                      }}
                    >
                      <img
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "cover",
                        }}
                        src={compareImg.preview_url}
                        alt={compareImg.title}
                        loading="lazy"
                      />
                    </Box> */}

										<Box
											sx={{
												mt: 3,
												color: theme.palette.mode === "dark" ? "#fff" : "#000",
											}}
										>
											<Typography sx={{ fontWeight: 500 }}>Comments</Typography>
											<Box
												maxHeight={225}
												sx={{ pr: 1, overflowY: "auto", mt: 1.3 }}
												className="overflow-scroll"
											>

												{compareImg.hotspots.length > 0 ? (
													compareImg.hotspots.map(
														(hotspot, index) =>
															hotspot.text && (
																<>
																	<Comment key={index} {...{ hotspot, index }} />
																</>
															)
													)
												) : (
													<Empty icon={<ModeEditOutlinedIcon />} sx={{ mb: 0, textTransform: "capitalize" }} text="no comments" />
												)}
											</Box>
										</Box>
									</>
								)}

							{/* <Box sx={{ textAlign: "right", mt: 3 }}>
              <Button
                variant="outlined"
                color="error"
                sx={{}}
                
              >
                Close
              </Button>
            </Box> */}
						</Box>
					</Box>
				</Modal>

				<ModalBox
					open={openRefundModal}
					onClose={() => { setOpenRefundModal(false) }} >
					<Box sx={{ height: { xs: "80vh", md: 'auto' }, overflow: 'auto', px: 2 }} className="overflow-scroll">
						<Box sx={{ mb: 4 }}>
							<Typography sx={{ color: theme.palette.mode === "dark" ? theme.palette.primary.contrastText : theme.palette.primary.main, fontSize: { xs: 20, xl: 22 } }}>Refund job</Typography>
						</Box>
						<Formik
							initialValues={{
								job_id: job.job_id,
								amount: 0,
								reason: ""
							}}
							onSubmit={async (values, { setSubmitting }) => {
								try {
									setSubmitting(true)
									const resp = await axios.post('jobs/refund/', values)
									setRefundInfo(prev => [...prev, resp.data.data.refund])
									alertMsg(resp.data.message, "success")
									setOpenRefundModal(false)
								}
								catch (err) {
									console.log("🚀 ~ file: Viewjob.jsx:792 ~ onSubmit={ ~ err:", err)
								}
								finally {
									setSubmitting(false)
								}
							}}
							validationSchema={refundValidation}
							enableReinitialize={true}
						>
							{({ submitForm, isSubmitting }) => (
								<Form>
									<Grid container spacing={2}>
										<Grid item xs={12} md={6}>
											<Box>
												<StrictNumberField
													sx={{ mb: 4 }}
													component={TextField}
													name="amount"
													label="Refund Amount *"
													inputProps={{ maxLength: 45 }}
													fullWidth
													type="number"
												/>
											</Box>

											<Box>
												<Field
													sx={{ mb: 2 }}
													component={TextField}
													name="reason"
													label="Refund reason *"
													inputProps={{ maxLength: 255 }}
													multiline
													className="textAreaScroll"
													rows={3}
													fullWidth
												/>
											</Box>
										</Grid>
									</Grid>
									<Box sx={{ mt: 4, textAlign: "right" }}>
										<Button
											variant="outlined"
											color="primary"
											sx={{ mr: 2 }}
											onClick={() => setOpenRefundModal(false)}
										>
											Cancel
										</Button>
										<Button
											variant="contained"
											color="primary"
											disabled={isSubmitting}
											onClick={submitForm}
										>
											Refund
										</Button>
									</Box>
								</Form>
							)}
						</Formik>
					</Box>
				</ModalBox>
			</Box >
		</Container >
	);
};

export default Viewjob;
